module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/feichong_infobanner01.5e62a10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/feichong_infobanner01.png
// module id = O2VY
// module chunks = 0